// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1KT1D","row":"ProcedureTreatmentSummary_row__1WM8r"};